export default [
    {
        name: "FitHotelList",
        path: "/fit/hotels",
        component: () => import("./views/FitHotelList.vue"),
        meta: {
            title: "FIT Hotels",
            perms: "hotels",
            icon: "fa-solid fa-hotel",
        },
    },
    {
        name: "FitHotelDetails",
        path: "/fit/hotels/:hotel",
        component: () => import("./views/FitHotelDetails.vue"),
    },
    {
        name: "FitSearch",
        path: "/fit/search",
        component: () => import("./views/FitSearch.vue"),
        meta: {
            title: "FIT Search",
            perms: "hotels",
            icon: "fa-solid fa-hotel",
        },
    },
    {
        name: "FitRateDetails",
        path: "/fit/rates/:rate",
        component: () => import("./views/FitRateDetails.vue"),
    },
];
